import { render, staticRenderFns } from "./base-statistics.vue?vue&type=template&id=b09c33ae&scoped=true&"
import script from "./base-statistics.vue?vue&type=script&lang=js&"
export * from "./base-statistics.vue?vue&type=script&lang=js&"
import style0 from "./base-statistics.vue?vue&type=style&index=0&id=b09c33ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09c33ae",
  null
  
)

export default component.exports